import React from 'react'
import { Box, Divider, Typography, alpha } from '@mui/material'
import SidebarItem from './SideBarItem'

type SidebarItemType = {
  text: string
  path: string
  icon?: JSX.Element
  onClick?: (ev: React.MouseEvent) => void
}

type SidebarSectionProps = {
  section: {
    title?: string
    items: SidebarItemType[]
  }
  open: boolean
  drawerTxtColor: string
  drawerActiveTxtColor: string
}

const SidebarSection: React.FC<SidebarSectionProps> = ({ section, open, drawerTxtColor, drawerActiveTxtColor }) => {
  return (
    <Box>
      {section.title && (
        <Box height={40} display="flex" alignItems="center" px={2}>
          {open ? (
            <Typography
              variant="subtitle2"
              sx={{
                pt: 1.5,
                color: alpha(drawerTxtColor, 0.7),
                textTransform: 'uppercase',
                fontSize: '11px',
                letterSpacing: '0.8px',
                fontWeight: 600, // ← Ligero pero no invisible
              }}>
              {section.title}
            </Typography>
          ) : (
            <Divider sx={{ width: '100%', borderColor: drawerTxtColor }} />
          )}
        </Box>
      )}

      {section.items.map((item, i) => (
        <SidebarItem
          key={item.path}
          path={item.path}
          text={item.text}
          icon={item.icon}
          onClick={item.onClick}
          open={open}
          drawerTxtColor={drawerTxtColor}
          drawerActiveTxtColor={drawerActiveTxtColor}
        />
      ))}
    </Box>
  )
}

export default SidebarSection
